<template>
  <centralized>
    <button
      data-e2e-attr="maintenance-bypass"
      v-if="allowBypass"
      class="fixed left-0 z-50 p-4 opacity-0 cursor-default bottom-13"
      @click="promptBypass"
    >
      BYPASS
    </button>
    <div
      class="
        flex flex-col
        items-center
        justify-center
        h-full
        pt-12
        tmsk-sky-blue-bg
      "
    >
      <div
        class="
          flex flex-col
          items-center
          justify-center
          w-full
          h-full
          mx-auto
          space-y-6
          mt-15
          sm:flex-row
          max-w-7xl
          sm:space-y-0 sm:space-x-6
        "
      >
        <!-- <div class="max-w-2xl space-y-3 text-center mt-15">
          <p class="text-3xl font-extrabold tmsk-blue-text">SORRY!</p>
          <p class="text-xl tmsk-blue-text">
            The website is currently under maintenance. We will be back shortly.
          </p>
        </div>
        <img src="@/assets/img/oops.png" class="h-60 sm:h-128" /> -->
        <div
          class="h-full max-w-3xl mx-2 mt-16 text-center sm:max-w-lg sm:mt-24"
        >
          <div class="flex">
            <div class="flex flex-col mx-2 justify-center">
              <p
                class="text-3xl font-extrabold sm:text-3xl tmsk-blue-text"
                data-e2e-attr="maintenance-message"
                v-html="header"
              >
                {{ header }}
              </p>
              <p
                class="tmsk-blue-text font-extrabold text-xl sm:text-2xl"
                data-e2e-attr="maintenance-message"
                v-html="subHeader"
              >
                {{ subHeader }}
              </p>
              <p
                class="tmsk-blue-text text-md sm:text-2xl mt-5"
                data-e2e-attr="maintenance-message"
                v-html="body"
              >
                {{ body }}
              </p>
            </div>
            <img
              src="@/assets/img/oops.png"
              class="w-1/4 sm:w-1/4 mx-auto mt-6 bottom-13 sm:static"
              data-e2e-attr="maintenance-footer-image"
            />
          </div>
          <!-- <img
            :src="footerImageUrl"
            class="fixed w-3/4 mx-auto mt-6 bottom-13 sm:static"
            data-e2e-attr="maintenance-footer-image"
          /> -->
        </div>
      </div>
    </div>
  </centralized>
</template>

<script>
import Centralized from '../../components/Layout/Centralized'
import { pollMaintenanceInfo } from './Maintenance.service'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { verifyPassword } from '../authentication/Authentication.repo'

export default {
  name: 'Maintenance',
  metaInfo() {
    return {
      title: 'StayMasked',
      // meta: [
      //   { property: 'og:title', content: 'StayMasked' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'StayMasked' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-01.jpg' }
      // ],
      link: [{ rel: 'canonical', href: window.location.href }],
    }
  },
  components: {
    Centralized,
  },
  data() {
    return {
      keySequence: [],
      header: 'Sorry!',
      subHeader: 'The website is currently under maintenance.',
      body: 'We will be back shortly.',
      footerImageUrl: '/img/home-illustration1.2e3e0e44.svg',
    }
  },
  computed: {
    ...mapState(['allowBypass', 'bypassSuccess']),
    ...mapGetters([]),
  },
  mounted() {
    this.handleHealthCheck()
  },
  created() {
    this.getMaintenanceMessage()
  },
  beforeRouteLeave(to, from, next) {
    if (this.bypassSuccess) {
      next()
    } else {
      next(false)
    }
  },
  methods: {
    ...mapMutations(['setBypassSuccess']),
    ...mapActions(['getMaintenanceMessage']),
    async handleHealthCheck() {
      await pollMaintenanceInfo(this.reRouteToHome)
    },
    reRouteToHome() {
      window.location.href = '/'
    },
    promptBypass() {
      const input = prompt('Please enter the password', '')

      if (input !== null && input !== '') {
        verifyPassword(input).then(() => {
          this.setBypassSuccess(true)
          this.$cookies.set('bpss', 'true', 30 * 60)
          this.$router.push({ name: 'Home', query: this.$route.query })
        })
      }
    },
  },
}
</script>

<style scoped>
.header-container {
  font-family: Century Gothic, CenturyGothic, AppleGothic;
}

@media only screen and (min-width: 401px) {
  .subHeader {
    font-size: 2rem;
  }
}
@media only screen and (max-width: 400px) {
  .subHeader {
    font-size: 1.2rem;
  }
}
</style>
